import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSize } from '../REDUX/actions';
import _ from 'lodash';
import { GAME_PAGE } from '../../HOME/const';
import { Background } from '../COMPONENTS/Background';
import BackButton from '../COMPONENTS/BackButton';
import { windowSize } from '../../HOME/utils';
import { selectorClass } from '../logic';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import Grid from '../COMPONENTS/Grid';

class SizePage extends Component {
  handleSize = size => e => {
    this.props.selectSize(size);
    this.props.goToPage(GAME_PAGE);
  };

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  sizeName = size => {
    switch (size) {
      default:
      case 3:
        return 'X-SMALL';
      case 4:
        return 'SMALL';
      case 5:
        return 'MEDIUM';
      case 6:
        return 'LARGE';
      case 7:
        return 'X-LARGE';
    }
  };

  render() {
    const { x, y } = windowSize();
    const cls = selectorClass(x, y);

    return (
      <div className="page-root">
        <div className={cls} style={{ backgroundImage: Background }}>
          {_.map([3, 4, 5, 6, 7], (size, i) => {
            const flow = x < y ? 'column' : 'row';
            return (
              <div
                key={size}
                className="option triangula-option"
                style={{ gridAutoFlow: flow }}
                onClick={this.handleSize(size)}
              >
                <Grid size={size} />
                <div style={{ color: 'white', textShadow: '2px 2px black', margin: '10px 20px' }}>
                  {this.sizeName(size)}
                </div>
              </div>
            );
          })}
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { selectSize, goToPage }
)(SizePage);
